// Mission step 2: Task editor
// Manages the list of tasks for the mission
// CREATED: Part of unified MissionModal architecture

import type { TaskItem } from '../../lib/supabase';
import { TaskItemEditor } from './TaskItemEditor';

interface MissionStep2TasksProps {
  items: TaskItem[];
  onItemsChange: (items: TaskItem[]) => void;
  loading: boolean;
}

export function MissionStep2Tasks({
  items,
  onItemsChange,
  loading,
}: MissionStep2TasksProps) {
  return (
    <div className="space-y-5 animate-fade-in">
      <TaskItemEditor
        items={items}
        onItemsChange={onItemsChange}
        disabled={loading}
      />

      {items.length === 0 && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm text-blue-800">
          <strong>Ajoutez au moins une tâche</strong> pour guider les opérateurs lors de l'exécution de cette mission.
        </div>
      )}
    </div>
  );
}
